function init(input)
{
  input.addEventListener("input", e => {
    input.value = input.value.replace(/\D/g, '');
  });
}

export { init };
